/* The fields inside an imported figure's chain nodes. The frame (rail, markers, standings) is
   `ReceiptChain.module.css`; this is only the small key/value grid a node carries, matching the
   calculated receipt's so the two read alike. Colours are tokens; nothing here is a literal. */

.wrap {
  margin-top: 8px;
}

.kv {
  display: grid;
  grid-template-columns: minmax(84px, auto) minmax(0, 1fr);
  gap: 2px 10px;
  font-size: var(--t-min);
  margin-top: 4px;
}

.k {
  color: var(--muted);
}

.v {
  color: var(--ink);
  min-width: 0;
  overflow-wrap: anywhere;
}

.mono {
  font-family: var(--mono);
  font-size: var(--t-min);
}

.link {
  color: var(--accent);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.missing {
  color: var(--muted);
  font-style: italic;
}
